import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../../store/SettingSlice';
import { getImgPath } from '../../store/JSTool';


export default function NewsSectionView() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    function tap(newsId){
        navigate(`/newsDetail?id=${newsId}`)
    }

    return (
        <Stack sx={{
            width: 1,
            bgcolor: '#EBEBEB',
            justifyContent: 'center',
            alignItems: 'center',
            pb: 2,
        }}>
            {/* 上边 */}
            <Stack sx={{
                flexDirection: 'row',
                alignItems: 'center',
                width: '1200px',
                mt: 3,
            }}>
                {/* 大图 */}
                <Box
                    onClick={() => { 
                        // window.open('https://eu.onepunchmanworld.com') 
                        tap(7);
                    }}
                    component={'img'}
                    src={getImgPath('news_poster_0.png')}
                    sx={{
                        width: '790px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.013)',
                        }
                    }} />

                {/* 右边 */}
                <Stack sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    ml: 5,
                }}>
                    <Typography sx={{
                        fontFamily: 'Lexend Deca',
                        fontSize: 40
                    }}>
                        2023/12/15
                    </Typography>

                    <Typography sx={{
                        fontFamily: 'Source Han Sans CN',
                        fontSize: 20,
                        mt: 2,
                    }}>
                        "ONE PUNCH MAN: WORLD" An Online 3D Action Game Launches On February 1st
                    </Typography>

                    {/* 按钮 */}
                    <Stack
                    onClick={()=>{
                        tap(7);
                    }}
                    sx={{
                        height: '60px',
                        minWidth: '210px',
                        bgcolor: 'black',
                        borderRadius: '8px',
                        mt: 5,
                        color: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        position: 'relative',
                        flexDirection: 'row',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.04)',
                        }
                    }}>
                        <Typography sx={{
                            fontFamily: settingData.fontFM,
                            fontSize: 19,
                        }}>
                           {settingData.langDic['lang9']}
                        </Typography>

                        <Box component={'img'}
                            src={getImgPath('arrow_right.png')}
                            sx={{
                                ml: 1.5,
                                right: '25px',
                                height: '15px',
                            }} />
                    </Stack>

                </Stack>

            </Stack>

            {/* 下边 */}
            <Stack
                sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '1200px',
                    mt: 3,
                }}>
                <NewsItem newsId={6} index={0} imgName='news_poster_1.jpg' time='2023/08/16' detail='"One Punch Man: World" Playable Demo Comes To Gamescom' color='#FF5F47' />
                <Box sx={{ width: '80px' }} />
                <NewsItem newsId={5} index={1} imgName='news_poster_2.jpg' time='2023/05/03' detail='"Street Fighter™. Duel" x "Devil May Cry™" collaboration event' color='#F09530' />
                <Box sx={{ width: '80px' }} />
                <NewsItem newsId={4} index={2} imgName='news_poster_3.png' time='2023/03/06' detail='"Street Fighter™, Duel" x "Monster Hunter" collaboration even' color='#FFC817' />
            </Stack>

            <Stack sx={{
                mt: 1.5,
                width: '1200px',
                flexDirection: 'row',
                justifyContent: 'end',
                alignItems: 'center',
            }}>
                <Typography
                    onClick={() => {
                        dispatch(settingActions.setNavIndex(2));
                        navigate('/newsList');
                    }}
                    sx={{
                        fontFamily: settingData.fontFM,
                        cursor: 'pointer',
                        fontSize: 22,
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.08)',
                        }
                    }}>
                    {settingData.langDic['lang10']}
                </Typography>

                <Box component={'img'}
                    src={getImgPath('arrow_right_black.png')}
                    sx={{
                        ml: 0.5,
                        height: '17px',
                        cursor: 'pointer',
                    }} />

            </Stack>

        </Stack>
    );
}

function NewsItem(props) {
    const navigate = useNavigate();

    function itemTap() {
        // if (props.index == 0) {
        //     window.open('https://eu.onepunchmanworld.com');

        // } else if (props.index == 1) {
        //     window.open('https://www.sfduelmobile.com');

        // } else if (props.index == 2) {
        //     window.open('https://www.sfduelmobile.com');

        // }

        navigate(`/newsDetail?id=${props.newsId}`)
    }

    return (
        <Stack
            onClick={itemTap}
            sx={{
                cursor: 'pointer',
            }}>
            <Box component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    width: 1,
                    borderRadius: '6px',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.02)',
                    }
                }} />

            <Typography sx={{
                fontFamily: 'Lexend Deca',
                fontSize: 24,
                mt: 1,
                textAlign: 'end'
            }}>
                {props.time}
            </Typography>

            <Typography sx={{
                fontFamily: 'Source Han Sans CN',
                fontSize: 15,
                fontWeight: 'bold',

            }}>
                {props.detail}
            </Typography>

            <Box sx={{
                mt: 1,
                height: '8px',
                bgcolor: props.color
            }} />
        </Stack>
    );
}